const CSS_URL_VALUE_REGEX = /url\(["']?([^"')]+)["']?\)/;

export function extractUrlFromCssValue(cssValue: string): string {
  const match = CSS_URL_VALUE_REGEX.exec(cssValue);
  return match?.[1] ?? cssValue;
}

export function hasBackgroundImageUrl(cssValue: string): boolean {
  return CSS_URL_VALUE_REGEX.test(cssValue);
}
